<template>
<div id="access-type-form-vrm">

    <div class="d-flex flex-column">
        <v-form v-model="formIsValid">
            <v-col class="switch-user" style="width: 96%" cols="12">
                <v-col cols="12" sm="12" class="d-flex justify-content-between p-0">
                    <v-checkbox
                        v-if="isAdmin"
                        class="ml-3"
                        v-model="formAcessTypeInfo.isFlatFee"
                        :label="$t('backoffice.modules-management.vrm.new-access.form.flat-fee')"
                    ></v-checkbox>
                    <div v-else class="ml-3"></div>
                    <v-switch
                        v-model="formAcessTypeInfo.isActive"
                        :class="formAcessTypeInfo.isActive ? 'custom-red' : ''"
                        color="green"
                        :label="formAcessTypeInfo.isActive ? $t('backoffice.general.active-status') : $t('backoffice.general.inactive-status')"
                    ></v-switch>
                </v-col>
            </v-col>
            <v-col cols="12" class="d-flex" :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'">
                <v-col cols="12" sm="3">
                    <v-select
                            :items="perfil.map(el => ({text: el.name, value: +el.value}))"
                            v-model="formAcessTypeInfo.profileId"
                            filled
                            :label="$t('backoffice.modules-management.vrm.components.access-type-form.profile')"
                            dense
                            @change="$emit('getPerfil', formAcessTypeInfo)"
                            :disabled="isAccountManager"
                            :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                </v-col>
                <v-col cols="12" sm="1" class="d-flex justify-center">

                    <v-tooltip bottom
                            v-if="!isAccountManager">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn fab x-small class="mt-2" @click="$emit('edit-button-form-access', formAcessTypeInfo)" v-bind="attrs" v-on="on">
                                <img src="/images/_SVGs/bo/edit_pencil.svg" :alt="$t('backoffice.modules-management.vrm.components.access-type-form.profile-options')" onload="SVGInject(this)" width="25" height="25" />
                            </v-btn>
                        </template>
                        <span>{{$t('backoffice.modules-management.vrm.components.access-type-form.profile-options')}}</span>
                    </v-tooltip>

                </v-col>
                <v-col cols="12" sm="3">
                    <v-select
                        :items="typologies.map(el => ({text: el.name, value: +el.value}))"
                        v-model="formAcessTypeInfo.vrmAccessVehicleTipologyId"
                        filled
                        :label="$t('backoffice.modules-management.vrm.components.access-type-form.vehicle-typology')"
                        dense
                        :disabled="isAccountManager"
                        :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                </v-col>
                <v-col cols="12" sm="2" v-if="makesDropData && makesDropData.length > 0">
                    <v-combobox
                      :items="makesDropData.map(el => ({text: el.name, value: el.value}))"
                      v-model="formAcessTypeInfo.restrictedMakes"
                      filled
                      multiple
                      :label="$t('makes-filter')"
                      dense
                      :disabled="isAccountManager"
                      small-chips
                    >
                    <template v-slot:selection="{ item, index }">
                      <v-chip x-small v-if="index === 0">
                        <span>{{ item.text && item.text.length > 20 ? item.text.slice(0, 20) + '...' : item.text }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">
                        (+{{ formAcessTypeInfo.restrictedMakes.length - 1 }})
                      </span>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="12" sm="3">
                        <v-textarea
                            :label="$t('backoffice.modules-management.vrm.components.access-type-form.observations')"
                            filled
                            v-model="formAcessTypeInfo.observations"
                            rows="1"
                            counter="200"
                            :disabled="isAccountManager && isAPI"
                            :rules="formRules.obsRules"
                        ></v-textarea>
                </v-col>
            </v-col>
            <v-col cols="12" class="d-flex" :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'">
                <v-col cols="12" sm="4">
                    <v-select
                        v-model="formAcessTypeInfo.dataSources"
                        :items="itemsDatasource.map(el => ({text: el.name, value: +el.value}))"
                        filled
                        chips
                        :label="$t('backoffice.modules-management.vrm.components.access-type-form.datasources')"
                        multiple
                        clearable
                        small-chips
                        :disabled="isAccountManager"
                        :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                    <v-select
                        :items="billingType.map(el => ({text: el.name, value: +el.value}))"
                        v-model="formAcessTypeInfo.billingTypeId"
                        filled
                        :label="$t('backoffice.modules-management.vrm.components.access-type-form.billing-type')"
                        dense
                        :disabled="isAccountManager"
                        :menu-props="{ top: false, offsetY: true }"
                    >
                    </v-select>
                </v-col>

                <v-col cols="12" sm="4">
                    <v-menu
                        ref="menuEndDate"
                        v-model="menuEndDate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="formAcessTypeInfo.endDate"
                                :label="$t('backoffice.modules-management.vrm.components.access-type-form.end-date')"
                                append-icon="mdi-calendar"
                                v-mask="'XXXX-XX-XX'"
                                @keypress="onlyNumberRule"
                                filled
                            >
                                <template v-slot:append>
                                    <v-fade-transition leave-absolute>
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-calendar</v-icon
                                        >
                                    </v-fade-transition>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="formAcessTypeInfo.endDate"
                            no-title
                            scrollable
                            :min="currentDate"
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="
                                    menuEndDate = false
                                "
                            >
                                {{ $t("backoffice.actions.cancel") }}
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="
                                    $refs.menuEndDate.save(
                                        formAcessTypeInfo.endDate
                                    )
                                "
                            >
                                {{ $t("backoffice.actions.ok") }}
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
            </v-col>
        </v-form>
    </div>
</div>
</template>

<script>
import { GenericServicesGetDropdowns } from "@services/GenericServices";
import { required } from '@src/utils/validations.js';
import moment from "moment";

export default {
    props: {
        formAcessTypeInfo: Object | Array,
        prefilled: Object | Array,
        makesDropData: Array
    },

    data() {
        return {
            modules: [],
            perfil: [],
            typologies: [
                    { name: 'Ligeiros', value: 1 },
            ],
            itemsDatasource: [
                { name: 'VRM Portugal', value: 1 },
                { name: 'VRM Espanha', value: 2 },
                { name: 'VRM França', value: 3 },
            ],
            billingType: [
                { name: this.$t('backoffice.modules-management.vrm.components.access-type-form.pack-use'), value: "2" },
                { name: this.$t('backoffice.modules-management.vrm.components.access-type-form.pack-unlimited'), value: "4" }
            ],
            formRules: {
                defaultRules: [required],
                obsRules: [v => !v || v && v.length === 0 || v && v.length <= 200 || this.$t('backoffice.modules-management.vrm.components.access-type-form.max-chars-rule')],
            },
            menuEndDate: false,
            currentDate: moment().format("YYYY-MM-DD"),
            formIsValid: false,
        }
    },

    computed: {
        isAccountManager() {
            return  this.$store.getters['auth/getState'].roleId == this.$globals.ROLES.ACCOUNT_MANAGER;
        },
        isAdmin() {
            return  this.$store.getters['auth/getState'].roleId == this.$globals.ROLES.ADMIN;
        },
        isAPI() {
            return this.formAcessTypeInfo.vrmAccessTipologyId == this.$globals.VRM_ACCESS_TIPOLOGY.API;
        }
    },
    watch: {
        prefilled: {
            handler: function(newValue) {
                newValue.forEach(el => {
                    this.modules.push({
                        name: el.vrmAccessTipologies.name,
                        value: el.vrmAccessTipologies.value,
                        dropDowns: el.dropDowns,
                    });
                });

                if(this.checkRoleIdByLoggedInUser == this.$globals.ROLES.ACCOUNT_MANAGER){
                    this.modules = this.modules.filter(el => el.value != this.$globals.ROLES.ACCOUNT_MANAGER);
                }

                this.resolveDropdowns();
                return newValue;
            },
            deep: true,
            immediate: true,
        },
        formIsValid: {
            handler: function(newValue, oldValue) {
                this.$emit('validationForm', newValue);
            }, deep: true, immediate: true
        }
    },
    methods: {
        resolveDropdowns() {
            let dropdowns = this.modules.filter(el => el.value == this.formAcessTypeInfo.vrmAccessTipologyId);

            if(dropdowns.length > 0) {
                this.perfil = dropdowns[0].dropDowns[0].profile;
                this.typologies = dropdowns[0].dropDowns[0].vrmAccessVehicleTipologies;
                this.itemsDatasource = dropdowns[0].dropDowns[0].dataSources;
                this.billingType = dropdowns[0].dropDowns[0].billingType

                this.$emit('isBalanceNewPack', dropdowns[0].dropDowns[0]);
            }
        },
        getGenericDrops() {
            GenericServicesGetDropdowns()
            .then(response => {
                    this.typologies = response.data.vrmAccessVehicleTipology
                    this.itemsDatasource = response.data.dataSource
                    this.billingType = response.data.billingType ? response.data.billingType : this.billingType;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get generic drops', error);
                })
        },
    },

    mounted() {
        this.getGenericDrops();

        this.prefilled.forEach(el => {
            this.modules.push({
                name: el.vrmAccessTipologies.name,
                value: el.vrmAccessTipologies.value,
                dropDowns: el.dropDowns,
            });
        });

        if(this.checkRoleIdByLoggedInUser == this.$globals.ROLES.ACCOUNT_MANAGER){
            this.modules = this.modules.filter(el => el.value != this.$globals.ROLES.ACCOUNT_MANAGER);
        }

        this.resolveDropdowns();
    }
}
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
#access-type-form-vrm {
    background-color: white;
    width: 100%
}

@media (max-width: 1025px) {
    #access-type-form-vrm {
        width: 100%
    }
}

::v-deep .switch-user{
    .v-input--switch__track:not(.green--text) {
        color: var(--v-error-lighten1) !important;
    }
    .v-input--switch__thumb:not(.green--text) {
        color: var(--v-error-base) !important;
    }
}
</style>
